import { render, staticRenderFns } from "./ScoreNumbers.vue?vue&type=template&id=7f59305e&scoped=true&"
import script from "./ScoreNumbers.vue?vue&type=script&lang=js&"
export * from "./ScoreNumbers.vue?vue&type=script&lang=js&"
import style0 from "./ScoreNumbers.vue?vue&type=style&index=0&id=7f59305e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f59305e",
  null
  
)

export default component.exports